import CloseIcon from "@mui/icons-material/Close";
import { Alert, Button, IconButton } from "@mui/material";

const NonCompliantBanner = ({ show = true, onClose }) => {
  if (!show) return null;

  const handleReview = () => {
    localStorage.setItem("reportType", "nonCompliantReport");
    window.open("/reports", "_blank");
  };

  return (
    <Alert
      severity="info"
      icon={false}
      sx={{
        margin: "10px 20px",
        alignItems: "center",
        "& .MuiAlert-message": {
          display: "flex",
          alignItems: "center",
        },

        "& .MuiAlert-action": {
          display: "flex",
          alignItems: "center",
          paddingTop: 0,
          paddingBottom: 0,
        },

        py: 1, // reduces default vertical padding
      }}
      action={
        <>
          <Button
            color="primary"
            size="small"
            onClick={handleReview}
            sx={{ marginRight: 1 }}
            variant="contained"
          >
            Review
          </Button>

          <IconButton color="inherit" size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </>
      }
    >
      📢 Non-Compliant report is available to review.
    </Alert>
  );
};

export default NonCompliantBanner;
